declare namespace $ {

	type $rise_range__min_shm_hitalama_range_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_range['min'] >
		,
		ReturnType< $rise_range['min'] >
	>
	type $rise_range__max_shm_hitalama_range_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_range['max'] >
		,
		ReturnType< $rise_range['max'] >
	>
	type $rise_range__step_shm_hitalama_range_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_range['step'] >
		,
		ReturnType< $rise_range['step'] >
	>
	type $rise_range__value_shm_hitalama_range_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_range['value'] >
		,
		ReturnType< $rise_range['value'] >
	>
	type $rise_range__unit_shm_hitalama_range_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_range['unit'] >
		,
		ReturnType< $rise_range['unit'] >
	>
	type $rise_range__enabled_shm_hitalama_range_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_range['enabled'] >
		,
		ReturnType< $rise_range['enabled'] >
	>
	type $rise_range__style_shm_hitalama_range_7 = $mol_type_enforce<
		({ 
			'position': string,
			'left': string,
			'top': ReturnType< $shm_hitalama_range['range_top'] >,
			'width': ReturnType< $shm_hitalama_range['range_width'] >,
			'height': ReturnType< $shm_hitalama_range['range_height'] >,
			'transform': ReturnType< $shm_hitalama_range['range_transform'] >,
			'transformOrigin': ReturnType< $shm_hitalama_range['range_transformOrigin'] >,
			'translate': ReturnType< $shm_hitalama_range['range_translate'] >,
		})  & ReturnType< $rise_range['style'] >
		,
		ReturnType< $rise_range['style'] >
	>
	export class $shm_hitalama_range extends $mol_view {
		range_top( ): string
		range_width( ): string
		range_height( ): string
		range_transform( ): string
		range_transformOrigin( ): string
		range_translate( ): string
		min( next?: number ): number
		max( next?: number ): number
		step( next?: number ): number
		value( next?: number ): number
		unit( ): string
		enabled( ): boolean
		vertical( next?: boolean ): boolean
		attr( ): ({ 
			'shm_hitalama_range_vertical': ReturnType< $shm_hitalama_range['vertical'] >,
		})  & ReturnType< $mol_view['attr'] >
		style( ): ({ 
			'width': string,
			'height': string,
			'minWidth': string,
			'minHeight': string,
			'position': string,
		})  & ReturnType< $mol_view['style'] >
		Body( ): $rise_range
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=range.view.tree.d.ts.map